import { render, staticRenderFns } from "./cmp-right-bottom.vue?vue&type=template&id=71e4e571"
import script from "./cmp-right-bottom.vue?vue&type=script&lang=js"
export * from "./cmp-right-bottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports